import { useEffect } from 'react';

export type SafetyCaseAttestationSaveHandler = () => Promise<void>;

export function useRegisterSafetyCaseSaveHandler(
  saveHandlerRef: React.MutableRefObject<SafetyCaseAttestationSaveHandler | null> | undefined,
  handler: SafetyCaseAttestationSaveHandler,
) {
  useEffect(() => {
    if (!saveHandlerRef) return undefined;
    saveHandlerRef.current = handler;
    return () => {
      if (saveHandlerRef.current === handler) {
        saveHandlerRef.current = null;
      }
    };
  }, [handler, saveHandlerRef]);
}

export async function runSafetyCaseAttestationSave(
  handlers: Array<SafetyCaseAttestationSaveHandler | null | undefined>,
): Promise<void> {
  for (const handler of handlers) {
    if (handler) {
      await handler();
    }
  }
}
